import { View } from '@play-co/timestep-core/ui';
import { Feature } from 'src/replicant/analytics';
import PopupBasic from '../../components/popups/PopupBasic';
import { AssetGroup } from '@play-co/timestep-core';
import ButtonScaleView from 'src/lib/ui/components/ButtonScaleView';
import sounds from 'src/lib/sounds';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import buttons from 'src/lib/ui/config/buttons';
import i18n from 'src/lib/i18n/i18n';
import { downscale } from 'src/conf/scale';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { LangBitmapFontTextShadowView } from 'src/lib/ui/components/LangBitmapFontTextShadowView';
import { getHomeShortcutGemsReward } from '../homeShortcut.utils';
import { addHomeShortcutSequence } from '../homeShortcut.sequence';
import { PopupDialogOrigin } from 'src/lib/popups/popupOpenClose';
import { match2CloseButtonY } from 'src/game/minigame/match2-timestep/components/match2PopupCloseButton';

export default class PopupHomeShortcut extends PopupBasic {
  private close: (success: boolean) => void;
  private origin: PopupDialogOrigin = 'hud';

  public getAssetsGroup() {
    return new AssetGroup([
      ...AssetGroup.constructURLs(['assets/ui/homeShortcut/popups/main/']),
    ]);
  }

  constructor(opts: { superview: View; close: (success: boolean) => void }) {
    super({
      superview: opts.superview,
      close: () => opts.close(false),
      width: downscale(1062),
      height: downscale(1400),
      boxOpts: {
        image: 'assets/ui/homeShortcut/popups/main/popup.png',
      },
      skipTitle: true,
      darkerBg: true,
      tracking: {
        feature: Feature.HOME_SHORTCUT._,
        $subFeature: Feature.HOME_SHORTCUT.POPUP._,
      },
    });

    this.close = opts.close;

    // Remove the default close button
    this.buttonClose.removeFromSuperview();

    // Title
    const title = new LangBitmapFontTextShadowView({
      superview: this.box,
      width: 440,
      height: 70,
      align: 'center',
      verticalAlign: 'center',
      centerOnOrigin: true,
      x: this.box.style.width / 2,
      y: 260,
      size: 46,
      font: 'Body',
      color: '#ffffff',
      textShadowOffsetX: 0,
      textShadowOffsetY: 6,
      textShadowOpacity: 0.2,
      localeText: () => i18n(`homeShortcut.popup.main.title`),
    });

    // Close button
    new ButtonScaleView({
      ...buttons.close,
      superview: this.box,
      x: this.box.style.width - buttons.close.width / 2 - 10,
      y: match2CloseButtonY + title.style.y,
      onClick: async () => {
        sounds.playSound('cancel');
        this.close(false);
      },
      tracking: {
        feature: Feature.HOME_SHORTCUT.POPUP._,
        $subFeature: Feature.HOME_SHORTCUT.POPUP.CLOSE,
      },
    });

    // Message #1
    new LangBitmapFontTextView({
      superview: this.box,
      width: 300,
      height: 100,
      align: 'left',
      verticalAlign: 'center',
      x: 135,
      y: 355,
      size: 28,
      font: 'Body',
      color: '#ffffff',
      localeText: () => i18n(`homeShortcut.popup.main.message1`),
    });

    // Message #2
    new LangBitmapFontTextView({
      superview: this.box,
      width: 300,
      height: 100,
      align: 'left',
      verticalAlign: 'center',
      x: 135,
      y: 505,
      size: 28,
      font: 'Body',
      color: '#ffffff',
      localeText: () => i18n(`homeShortcut.popup.main.message2`),
    });

    // Message #3
    new LangBitmapFontTextView({
      superview: this.box,
      width: 300,
      height: 50,
      align: 'left',
      verticalAlign: 'center',
      x: 135,
      y: 650,
      size: 28,
      font: 'Body',
      color: '#ffffff',
      localeText: () => i18n(`homeShortcut.popup.main.message3`),
    });

    // Gems reward
    new LangBitmapFontTextView({
      superview: this.box,
      width: 100,
      height: 50,
      align: 'center',
      verticalAlign: 'center',
      x: 145,
      y: 696,
      size: 28,
      font: 'Body',
      color: '#ffffff',
      localeText: () => `+${getHomeShortcutGemsReward('launch')}`,
    });

    // CTA button
    new ButtonScaleViewWithText({
      superview: this.box,
      ...buttons.secondary,
      fontSize: 45,
      x: this.box.style.width / 2,
      y: this.box.style.height - 90,
      centerOnOrigin: true,
      labelOffsetX: -3,
      labelOffsetY: -2,
      font: 'Body',
      width: 287,
      height: 100,
      localeText: () => i18n(`homeShortcut.popup.main.cta`),
      onClick: async () => {
        sounds.playSound('ok');
        addHomeShortcutSequence(this.origin);
      },
      tracking: {
        feature: Feature.HOME_SHORTCUT.POPUP._,
        $subFeature: Feature.HOME_SHORTCUT.POPUP.CTA,
      },
    });
  }

  public override init(args: { origin: PopupDialogOrigin }) {
    super.init({});
    this.origin = args.origin;
  }
}
